export enum AccessType {
  READ = 'READ',
  WRITE = 'WRITE'
}
